import { createSlice } from '@reduxjs/toolkit';

// Utility function
const formatPeriod = (date) => {
  const date1 = new Date(date[0]);
  const date2 = new Date(date[1]);
  const dateOne = `${date1.toLocaleString('default', { month: 'long' })} ${date1.getDate()}, ${date1.getFullYear()}`;
  const dateTwo = `${date2.toLocaleString('default', { month: 'long' })} ${date2.getDate()}, ${date2.getFullYear()}`;

  return `${dateOne} To ${dateTwo}`;
};

const initialState = {
  periodOneDate: null,
  periodTwoDate: null,
  isBothSpecificPeriod: false,
  periodOneHeading: '',
  periodTwoHeading: '',
  periodOneDuration: '',
  periodTwoDuration: ''
};

const notesTitlePeriodSlice = createSlice({
  name: 'notesPeriod',
  initialState,
  reducers: {
    setPeriodOneDate: (state, action) => {
      state.periodOneDate = action.payload;
    },
    setPeriodTwoDate: (state, action) => {
      state.periodTwoDate = action.payload;
    },
    setIsBothSpecificPeriod: (state, action) => {
      state.isBothSpecificPeriod = action.payload;
    },
    setPeriodOneHeading: (state, action) => {
      state.periodOneHeading = action.payload;
    },
    setPeriodTwoHeading: (state, action) => {
      state.periodTwoHeading = action.payload;
    },
    updateNotesPeriodState: (state, action) => {
        const { exel } = action.payload;
        if (exel?.header?.periodType && exel?.header?.periodType.length > 1) {
          state.periodOneDate = exel?.header?.period[0];
          state.periodTwoDate = exel?.header?.period[1];
          let dateOne, dateTwo;
          if (exel.header.periodType[0].includes("To") && exel.header.periodType[1].includes("To")) {
            dateOne = exel.header.periodType[0].split("To");
            dateTwo = exel.header.periodType[1].split("To");
            state.periodOneDate = formatPeriod(dateOne);
            state.periodTwoDate = formatPeriod(dateTwo);
            state.isBothSpecificPeriod = false;
          } else if (exel.header.periodType[0].includes("To") && !exel.header.periodType[1].includes("To")) {
            dateOne = exel.header.periodType[0].split("To");
            state.periodOneDate = formatPeriod(dateOne);
            state.periodTwoDate = exel.header.period[1];
            state.isBothSpecificPeriod = false;
          } else if (!exel.header.periodType[0].includes("To") && exel.header.periodType[1].includes("To")) {
            dateTwo = exel.header.periodType[1].split("To");
            state.periodOneDate = exel.header.period[0];
            state.periodTwoDate = formatPeriod(dateTwo);
            state.isBothSpecificPeriod = false;
          } else {
            state.isBothSpecificPeriod = true;
          }
        } else if (exel?.header?.periodType && exel?.header?.periodType.length === 1) {
          state.periodOneDate = exel?.header?.period[0];
          if (exel.header.periodType[0].includes("To")) {
            const dateOne = exel.header.periodType[0].split("To");
            state.periodOneDate = formatPeriod(dateOne);
            state.isBothSpecificPeriod = false;
          }
        }
      },
    updateNotesPeriodHeadings: (state, action) => {
      const { exel } = action.payload;
      if (exel?.header?.periodType && exel?.header?.periodType.length > 1) {
        if (exel?.header?.periodType[0].includes("To") && exel?.header?.periodType[1].includes("To")) {
          state.periodOneHeading = "THE PERIODS FROM"
        } else if (exel?.header?.periodType[0].includes("To") && !exel?.header?.periodType[1].includes("To")) {
            state.periodOneHeading = "THE PERIODS FROM"
        } else if (!exel?.header?.periodType[0].includes("To") && exel?.header?.periodType[1].includes("To")) {
            state.periodTwoHeading = "THE PERIODS FROM"
        }
      }else if (exel?.header?.periodType && exel?.header?.periodType.length === 1) {
        if (exel?.header?.periodType[0].includes("To")) {
            state.periodOneHeading = "THE PERIOD FROM"
        }
      }
    
      if(exel?.header?.periodType && exel?.header?.periodType.length > 1 && !exel?.header?.periodType[0].includes("To") ) {
        if(!exel?.header?.periodType[0].includes("To")) {
          state.periodOneDuration = exel.header.periodType[0].split(" ")[0];
        }
        if(!exel?.header?.periodType[1].includes("To")) {
          state.periodTwoDuration = exel.header.periodType[1].split(" ")[0];
        }
        
      } else if (exel?.header?.periodType && exel?.header?.periodType.length === 1 && !exel?.header?.periodType[0].includes("To")) {
        state.periodOneDuration = exel.header.periodType[0].split(" ")[0];
        // periodOneDate = exel.header.periodType[0];
      }
    
      if (!exel?.header?.periodType) {
        state.periodOneHeading = "THE YEARS";
      }
    
      if(exel?.header?.periodType && exel?.header?.periodType.length > 1 && state.periodOneDuration === state.periodTwoDuration) {
        if ( state.periodOneDuration === "YE" ) {
            state.periodOneHeading = "Years Ended";
            state.periodTwoHeading = "Years Ended";
        } else if ( state.periodOneDuration === "HYE" ) {
            state.periodOneHeading = "Six Months Ended";
            state.periodTwoHeading = "Six Months Ended";
        } else if ( state.periodOneDuration === "QE" ) {
            state.periodOneHeading = "Three Months Ended";
            state.periodTwoHeading = "Three Months Ended";
        }
      } else if (exel?.header?.periodType && exel?.header?.periodType.length > 1 && state.periodOneDuration !== state.periodTwoDuration) {
        if (state.periodOneDuration === "YE") {
            state.periodOneHeading = "Year Ended";
        } else if (state.periodOneDuration === "HYE") {
            state.periodOneHeading = "Six Months Ended";
        } else if (state.periodOneDuration === "QE") {
            state.periodOneHeading = "Three Months Ended";
        };
    
        if (state.periodTwoDuration === "YE") {
            state.periodTwoHeading = "Year Ended";
        } else if (state.periodTwoDuration === "HYE") {
            state.periodTwoHeading = "Six Months Ended";
        } else if (state.periodTwoDuration === "QE") {
            state.periodTwoHeading = "Three Months Ended";
        }
      } else if(exel?.header?.periodType && exel?.header?.periodType.length === 1 && state.periodOneDuration) {
        if (state.periodOneDuration === "YE") {
            state.periodOneHeading = "Year Ended";
        } else if (state.periodOneDuration === "HYE") {
            state.periodOneHeading = "Six Months Ended";
        } else if (state.periodOneDuration === "QE") {
            state.periodOneHeading = "Three Months Ended";
        } 
      } 
    }
  }
});

export const {
  setPeriodOneDate,
  setPeriodTwoDate,
  setIsBothSpecificPeriod,
  setPeriodOneHeading,
  setPeriodTwoHeading,
  updateNotesPeriodState,
  updateNotesPeriodHeadings
} = notesTitlePeriodSlice.actions;

export default notesTitlePeriodSlice;
